<template>
  <fade-transition :duration="150">
    <div
      class="fixed pin-t pin-l w-screen h-screen z-50 bg-overlay overflow-y-auto"
    >
      <div
        v-if="$slots.default"
        class="flex items-start justify-center py-8 min-h-screen"
        @click.self="$emit('close')"
      >
        <div
          :class="containerClass"
        >
          <slot />
        </div>
      </div>
      <slot name="containerless" />
    </div>
  </fade-transition>
</template>

<script>
import {FadeTransition} from 'vue2-transitions'
export default {
	name: 'AppModal',
	components: { FadeTransition },
  props: {
    containerClass: {
      type: String,
      default: 'py-6'
    }
  },
	created() {
		const listener = document.addEventListener("keydown", e => {
		if (e.keyCode === 27) {
						this.$emit('close')
				}
		})
		document.body.classList.add('overflow-hidden');

		this.$once("hook:beforeDestroy", () => {
				document.removeEventListener("keydown", listener)
				document.body.classList.remove('overflow-hidden');
		})
	}
}
</script>

<style>
	.bg-overlay {
    backdrop-filter: blur(10px);
		background-color: config('colors.primary-950')CD;
	}
</style>
